import React from "react";
import PropTypes from "prop-types";
import formatDateAsShort from "./formatDateAsShort";
import trackEvent from "../ga/trackEvent";

const Notification = ({
  notification,
  AboutNotification,
  NotificationLink,
  IconWrapper,
  NotificationIcon,
  BodyWrapper,
  NotificationText,
  Subject,
  Time,
}) => {
  const onclickNotification = () => {
    trackEvent(
      "Notification",
      "Clicked Notifcation",
      "Clicked on a notifcation"
    );
  };
  return (
    <NotificationLink
      key={notification.id}
      href={notification.link}
      title="View"
      data-remote="true"
      data-turbolinks="false"
      rel="nofollow"
      data-method="put"
      onClick={onclickNotification}
      className={`read-${notification.read}`}
    >
      <AboutNotification>
        <IconWrapper>
          <NotificationIcon className={`${notification.icon} notification`} />
        </IconWrapper>
        <BodyWrapper>
          <Subject>{notification.subject}</Subject>
          <NotificationText
            dangerouslySetInnerHTML={{
              __html: notification.text,
            }}
          />
        </BodyWrapper>
        <Time>{formatDateAsShort(notification.time)}</Time>
      </AboutNotification>
    </NotificationLink>
  );
};

Notification.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.string,
    read: PropTypes.bool,
    subject: PropTypes.string,
    text: PropTypes.string,
    time: PropTypes.number,
    icon: PropTypes.string,
  }).isRequired,
  AboutNotification: PropTypes.instanceOf(Object).isRequired,
  NotificationLink: PropTypes.instanceOf(Object).isRequired,
  IconWrapper: PropTypes.instanceOf(Object).isRequired,
  NotificationIcon: PropTypes.instanceOf(Object).isRequired,
  BodyWrapper: PropTypes.instanceOf(Object).isRequired,
  NotificationText: PropTypes.instanceOf(Object).isRequired,
  Subject: PropTypes.instanceOf(Object).isRequired,
  Time: PropTypes.instanceOf(Object).isRequired,
};

export default Notification;
